import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { getPaymentList, payWeeklyCycle } from "../../../../Service/payment";

const Payment = () => {
  const [expandedRows, setExpandedRows] = useState({});
  const [paymentList, setPaymentList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPayment();
  }, []);

  const getPayment = async () => {
    setLoading(true);
    const res = await getPaymentList();
    if (res.error == false) {
      setPaymentList(res.data);
    }
    setLoading(false);
  };

  const initiatePayment = async (cycle, payID, cycleID, paymentID) => {
    if (window.confirm("Do you want to proceed with the payment?")) {
      const res = await payWeeklyCycle({ cycle, payID, cycleID, paymentID });
      if (res.error == false) {
        getPayment();
      }
    }
  };

  const toggleRowExpansion = (visitId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [visitId]: !prev[visitId],
    }));
  };

  return (
    <div className="p-4 bg-gray-100 min-h-screen overflow-auto">
      <div className="bg-white shadow-md rounded-md overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center h-[85vh]">
            <p className="text-gray-500 text-lg">Loading payments...</p>
          </div>
        ) : paymentList?.length === 0 || !paymentList ? (
          <div className="flex flex-col items-center justify-center h-[85vh]">
            <p className="text-gray-500 text-xl font-semibold">
              No Visits Available
            </p>
            <p className="text-gray-400 text-sm mt-2">
              There are no payment records to display
            </p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-gray-700">
              <thead className="bg-gray-200 text-left">
                <tr>
                  <th className="p-3 text-left text-md font-semibold">
                    Visit ID
                  </th>
                  <th className="p-3 text-left text-md font-semibold">
                    Total Earned
                  </th>
                  <th className="p-3 text-left text-md font-semibold">
                    Total Payable
                  </th>
                  <th className="p-3 text-left text-md font-semibold">Cycle</th>
                  <th className="p-3 text-center text-md font-semibold">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {paymentList.map((payment) => (
                  <React.Fragment key={payment._id}>
                    <tr className="border-b hover:bg-gray-50">
                      <td className="p-3 text-left font-medium">
                        {payment?.visitID?.jobID}
                      </td>

                      <td className="p-3 text-left font-medium">
                        ₹
                        {payment?.cycle?.report?.reduce(
                          (total, info) => total + info.amount,
                          0
                        )}
                      </td>
                      <td className="p-3 text-left font-medium">
                        ₹
                        {(
                          payment?.cycle?.report?.reduce(
                            (total, info) => total + info.amount,
                            0
                          ) * 0.8
                        ).toFixed(2)}
                      </td>
                      <td className="p-3 text-left font-medium">
                        {payment?.cycle?.number} / {payment?.totalCycle}
                      </td>
                      <td className="p-3 flex items-center justify-center space-x-2">
                        <button
                          onClick={
                            payment.cycle.paid
                              ? () => {}
                              : () =>
                                  initiatePayment(
                                    payment.cycle.report,
                                    payment._id,
                                    payment.cycle._id,
                                    payment.visitID.paymentInfo.paidInfo
                                      .metadata.razorpay_payment_id
                                  )
                          }
                          className={`text-white px-2 py-1 rounded text-sm font-medium ${
                            payment.cycle.paid
                              ? "bg-green-500 cursor-not-allowed"
                              : "bg-blue-500 hover:bg-green-600"
                          }`}
                          disabled={payment.cycle.paid}
                        >
                          {payment.cycle.paid ? "Paid" : "Pay"}
                        </button>
                        <button
                          onClick={() => toggleRowExpansion(payment._id)}
                          className="text-gray-600 hover:bg-gray-200 p-2 rounded text-sm font-medium"
                        >
                          {expandedRows[payment._id] ? (
                            <ChevronUp />
                          ) : (
                            <ChevronDown />
                          )}
                        </button>
                      </td>
                    </tr>
                    {expandedRows[payment._id] && (
                      <tr>
                        <td colSpan="5" className="p-4 bg-gray-50">
                          <table className="w-full text-sm text-gray-700">
                            <thead>
                              <tr className="bg-blue-50 text-left">
                                <th className="p-2 text-left font-medium">
                                  Specialist Name
                                </th>
                                <th className="p-2 text-left font-medium">
                                  Role
                                </th>
                                <th className="p-2 text-left font-medium">
                                  Date
                                </th>
                                <th className="p-2 text-left font-medium">
                                  Duty Type
                                </th>
                                <th className="p-2 text-right font-medium">
                                  Bonus
                                </th>
                                <th className="p-2 text-right font-medium">
                                  Penalty
                                </th>
                                <th className="p-2 text-right font-medium">
                                  Fees
                                </th>
                                <th className="p-2 text-right font-medium">
                                  Total Earned
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {payment.cycle.info.map((info, index) => (
                                <tr
                                  key={index}
                                  className={
                                    index % 2 !== 0 ? "bg-gray-100" : ""
                                  }
                                >
                                  <td className="p-2 text-left font-medium">
                                    {
                                      info.specialistID.personalInfo.basicInfo
                                        .nameInfo.title
                                    }
                                    .{" "}
                                    {
                                      info.specialistID.personalInfo.basicInfo
                                        .nameInfo.fullName
                                    }
                                  </td>
                                  <td className="p-2 text-left font-medium">
                                    {info.specialistID.role
                                      .charAt(0)
                                      .toUpperCase() +
                                      info.specialistID.role
                                        .slice(1)
                                        .toLowerCase()}
                                  </td>
                                  <td className="p-2 text-left font-medium">
                                    {info.date}
                                  </td>
                                  <td className="p-2 text-left font-medium">
                                    {info.type.charAt(0).toUpperCase() +
                                      info.type.slice(1).toLowerCase()}
                                  </td>
                                  <td className="p-2 text-right font-medium">
                                    ₹{info.bonus}
                                  </td>
                                  <td className="p-2 text-right font-medium">
                                    ₹{info.penalty}
                                  </td>
                                  <td className="p-2 text-right font-medium">
                                    ₹{info.fees}
                                  </td>
                                  <td className="p-2 text-right font-medium font-bold">
                                    ₹{info.totalEarned}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Payment;
